import React, { useState, useContext } from 'react'
import { components } from 'cng-web-lib'
import {
    Box,
    Grid,
    InputAdornment,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { A6TranslationContext } from './contexts/A6TranslationContext'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    table: {
        '& .MuiTableHead-root': {
            backgroundColor: theme.palette.background.sectionOddBg,
            '& .MuiTableCell-head': {
                borderBottom: 0,
                fontSize: 12,
                fontWeight: 700,
                lineHeight: 1.2,
                textTransform: 'uppercase'
            }
        },
        '& .MuiTableBody-root': {
            '& .MuiTableRow-root': {
                '&:last-child': {
                    '& .MuiTableCell-root': {
                        borderBottom: 0
                    }
                }
            }
        },
        '& .MuiTableCell-root': {
            padding: '8px 16px'
        }
    }
}))

const { button: { CngButton, CngIconButton } } = components

function TaciOcnA6RouteTable(props) {
    const { data, onAddRoute, onEditRoute, onDeleteRoute } = props
    const { getTranslatedText } = useContext(A6TranslationContext)

    const classes = useStyles()

    const [searchTerm, setSearchTerm] = useState('')

    const filtered = searchTerm !== '' ?
        data.filter((route) => route.portOfCall.toLowerCase().includes(searchTerm.toLowerCase())) : data

    return (
        <>
            <Box mb={2}>
                <Grid container spacing={2}>
                    <Grid item xs>
                        {data.length > 0 && (
                            <TextField
                                fullWidth
                                onChange={(event) => setSearchTerm(event.target.value)}
                                placeholder='Search in your entries'
                                size='small'
                                variant='outlined'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <FontAwesomeIcon icon={['fal', 'search']} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                    </Grid>

                    {onAddRoute && (
                        <Grid item xs='auto'>
                            <CngButton color='secondary' onClick={onAddRoute} size='medium'
                                startIcon={<FontAwesomeIcon icon={['fal', 'plus-circle']} />}>
                                Add Route
                            </CngButton>
                        </Grid>
                    )}
                </Grid>
            </Box>

            <TableContainer>
                <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{getTranslatedText('A6', 'portOfCall')}</TableCell>
                            <TableCell>{getTranslatedText('A6', 'terminal')}</TableCell>
                            <TableCell>{getTranslatedText('A6', 'pierNo')}</TableCell>
                            {(onEditRoute || onDeleteRoute) && (<TableCell align='right'>Action</TableCell>)}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filtered.length > 0 ? (
                            filtered.map((route, index) => (
                                <TableRow key={route._id || route.id || index}>
                                    <TableCell>{route.portOfCall}</TableCell>
                                    <TableCell>{route.terminal}</TableCell>
                                    <TableCell>{route.pierNo}</TableCell>
                                    {(onEditRoute || onDeleteRoute) && (
                                        <TableCell>
                                            <Box display='flex' flexDirection='row' justifyContent='flex-end' style={{ gap: 8 }}>
                                                {onEditRoute && (
                                                    <CngIconButton type='outlined' icon={['fal', 'pen']} onClick={() => onEditRoute(route)} size='small' />
                                                )}
                                                {onDeleteRoute && (
                                                    <CngIconButton type='outlined' icon={['fal', 'trash']} onClick={() => onDeleteRoute(route)} size='small' />
                                                )}
                                            </Box>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align='center' colSpan={3 + (onEditRoute || onDeleteRoute ? 1 : 0)}>
                                    <Typography variant='body2' color='textSecondary'>
                                        No records to display
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default TaciOcnA6RouteTable
